module.exports = __webpack_public_path__ + "static/media/02d.6ca1110a.png";